/**
 * Shared header for all public (unauthenticated) pages.
 *
 * Renders a consistent nav bar with logo, page links, and sign-in button.
 * The `current` prop highlights the active page link.
 */

export default function PublicHeader({
  current,
}: {
  current?: "home" | "docs" | "guides" | "blog";
}) {
  const linkClass = (page: string) =>
    `hidden text-sm sm:inline ${
      current === page
        ? "font-medium text-slate-950"
        : "text-slate-600 hover:text-slate-950"
    }`;

  return (
    <header class="border-b border-slate-200/60 bg-white/90 backdrop-blur-sm">
      <div class="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <a href="/" class="text-lg font-bold tracking-tight text-slate-950">
          webhookstorage
        </a>
        <nav class="flex items-center gap-4 text-sm">
          <a href="/guides" class={linkClass("guides")}>
            Guides
          </a>
          <a href="/docs" class={linkClass("docs")}>
            Docs
          </a>
          <a href="/blog" class={linkClass("blog")}>
            Blog
          </a>
          <a
            href="/login"
            class="rounded-full border border-slate-300 px-4 py-2 font-medium text-slate-950 transition hover:border-slate-400 hover:bg-slate-50"
          >
            Sign in
          </a>
        </nav>
      </div>
    </header>
  );
}
